module.exports = __webpack_public_path__ + "img/m-bg.b2591fdd.png";